import { isAxiosError } from "axios";
import axiosInstance from "../../utility/axiosInstance";

// types and state
import {
  setCourse,
  updateCourse,
  deleteCourse,
  setLoading,
} from "../../store/slices/course";
import { openNotification } from "../../components/ui/alerts";

export const get_courses = async (dispatch: Function) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get("/get-college-major");

    dispatch(setCourse(response.data));
  } catch (error) {
    dispatch(setCourse([]));
  }
  dispatch(setLoading());
};

export const create_course = async (
  dispatch: Function,
  data: { name: string },
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post("/create-college-major", data);

    dispatch(updateCourse(response.data?.data));
  } catch (error) {
    // dispatch(setRole([]));
  }
  dispatch(setLoading());
};

export const delete_course = async (
  dispatch: Function,
  id: string | number,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.delete(`/delete-college-major/${id}`);

    dispatch(deleteCourse(id));
    openNotification({
      message: response?.data?.message || "College major deleted successfully",
      status: "success",
    });
  } catch (error) {
    if (isAxiosError(error)) {
      openNotification({
        message:
          error?.response?.data?.message || "Failed to delete college major",
        status: "error",
      });
    }
  }
  dispatch(setLoading());
};

export const delete_college_major = delete_course;
